// extracted by mini-css-extract-plugin
export default {"gameCenterContentWrapper":"GameCenterCommonModal_gameCenterContentWrapper__w1cPJ","gamesEmptyFooter":"GameCenterCommonModal_gamesEmptyFooter__WjjLV"};